<mat-dialog-content>
    <mat-stepper [linear]="true" #stepper>
        <form [formGroup]="formGroup">
            <mat-step [completed]="false" [editable]="false">
                <ng-template matStepLabel>{{ 'Contact.UpdateInformation' | translate }}</ng-template>
                <div class="row">
                    <div class="col-12 col-md-8">
                        @if (data) {
                            <p>
                                @switch (inputType()) {
                                    @case ('email') {
                                        {{ 'DeliveryMethod.EnterYourEmail' | translate }}.
                                    }
                                    @case ('mobile') {
                                        {{ 'DeliveryMethod.EnterYourMobile' | translate }}.
                                    }
                                    @default {
                                        {{ 'Contact.EmailOrMobile' | translate }}
                                    }
                                }
                            </p>
                        }
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        @switch (inputType()) {
                            @case ('email') {
                                <sl-input type="email" placeholderKey="Contact.Email" [control]="formGroup.controls['emailOrMobile']" />
                            }
                            @case ('mobile') {
                                <sl-input
                                    type="tel"
                                    placeholderKey="Contact.MobileNumber"
                                    [control]="formGroup.controls['emailOrMobile']" />
                            }
                            @default {
                                <sl-input
                                    type="text"
                                    placeholderKey="Contact.EmailOrMobile"
                                    [control]="formGroup.controls['emailOrMobile']" />
                            }
                        }
                    </div>
                </div>
            </mat-step>
            <mat-step [completed]="false" [editable]="false">
                <ng-template matStepLabel>{{ 'General.EnterCode' | translate }}</ng-template>
                <div class="row">
                    <div class="col-12 col-md-8">
                        <p [innerHTML]="'DeliveryMethod.ConfirmationCodeSent' | translate: { value: formGroup.value.emailOrMobile }"></p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <sl-input
                            type="text"
                            placeholderKey="Contact.ConfirmationCode"
                            [control]="formGroup.controls['confirmationCode']" />
                    </div>
                </div>
            </mat-step>
        </form>
        <mat-step [completed]="false" [editable]="false">
            <ng-template matStepLabel>{{ 'Contact.ValidatingData' | translate }}</ng-template>
            <mat-progress-bar mode="indeterminate" />
        </mat-step>
    </mat-stepper>
</mat-dialog-content>
<mat-dialog-actions class="text-right">
    <div class="w-100">
        @if (stepper.selectedIndex === 0) {
            <button mat-flat-button mat-dialog-close>
                {{ 'General.Cancel' | translate }}
            </button>
        }
        @if (stepper.selectedIndex > 0) {
            <button mat-flat-button [disabled]="stepper.selectedIndex !== 1" (click)="goBackTo()">
                {{ 'General.Previous' | translate }}
            </button>
        }
        <button mat-flat-button color="primary" [disabled]="!canMoveForward" [class.spinner]="isSendingField" (click)="saveData()">
            {{ 'General.Next' | translate }}
            <mat-icon>arrow_forward</mat-icon>
        </button>
    </div>
</mat-dialog-actions>
